<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="secondary">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>
      @if (walkingFarm$ | async) {
        {{ (walkingFarm$ | async)?.name }}
      } @else {
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      }
    </ion-title>
    <ion-buttons slot="primary">
      <ion-button class="tw:relative tw:overflow-visible" [routerLink]="['filter']">
        <ion-icon slot="icon-only" src="/assets/svg/filter.svg"> </ion-icon>
        @if (filtersAppliedNumber$ | async) {
          <ion-badge class="tw:absolute tw:-top-0.5 tw:-right-1" color="warning">{{
            filtersAppliedNumber$ | async
          }}</ion-badge>
        }
      </ion-button>
      <ion-button [routerLink]="['help']">
        <ion-icon slot="icon-only" src="/assets/svg/help.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment (ionChange)="segmentChange($event)" [value]="selectedTab">
      <ion-segment-button [value]="walkingFarmViewTabs.Map">
        <ion-label>Map</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="walkingFarmViewTabs.Details">
        <ion-label>Details</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="walkingFarmViewTabs.List">
        <ion-label>List</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
  @if (selectedTab === walkingFarmViewTabs.List) {
    <ion-toolbar>
      <ion-searchbar
        (ionInput)="filterProperties($event)"
        (ionClear)="clearFilterProperties()"
        [debounce]="100"
      ></ion-searchbar>
    </ion-toolbar>
  }
</red-header-content>
@switch (selectedTab) {
  @case (walkingFarmViewTabs.Map) {
    <ion-content color="light" [scrollX]="false" [scrollY]="false">
      <red-walking-farm-view-map [walkingFarmId]="walkingFarmId"></red-walking-farm-view-map>
    </ion-content>
  }
  @case (walkingFarmViewTabs.Details) {
    <red-page-content [paddingBottom]="true">
      <red-walking-farm-view-details
        [walkingFarmId]="walkingFarmId"
        [walkingFarm]="walkingFarm$ | async"
        [isNonDisclosureState]="(isNonDisclosureState$ | async) === true"
      ></red-walking-farm-view-details>
    </red-page-content>
  }
  @case (walkingFarmViewTabs.List) {
    <red-page-content [scrollX]="false" [scrollY]="false">
      <red-walking-farm-view-list
        class="tw:block tw:h-full tw:w-full"
        [walkingFarmId]="walkingFarmId"
        [propertiesFilterText]="propertiesFilterText"
      ></red-walking-farm-view-list>
    </red-page-content>
  }
}
